const location = (state = { location: null }, action) => {
  switch (action.type) {
    case 'UPDATE_LOCATION':
      return {
        ...state,
        location: action.location,
      };

    default:
      return state;
  }
};

export default location;

export const getLocation = (state) => state.location;
